module.exports = __webpack_public_path__ + "public/img/noData.74a0ff8a.png";